"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceData = class UcInvoiceData extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onSaveNotes(...args) {
        console.log(this.invoice.notes);
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    leftColumnLabelCols;
    ux;
    dataMembers = ['leftColumnLabelCols', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                leftColumnLabelCols: 4,
                ux: null,
            },
        };
    }
    get isReadonly() {
        if (this.loaded) {
            return false;
        }
        return null;
    }
    get invoiceTypeName() {
        if (this.loaded) {
            return this.invoice.invoice_type === "correction" ? this.$fn.pgettext("InvoiceType", "Correction") :
                (this.invoice.invoice_type === "storno" ? this.$fn.pgettext("InvoiceType", "Storno") :
                    (this.invoice.invoice_type === "proforma" ? this.$fn.pgettext("InvoiceType", "Pro Forma") : "?"));
        }
        return null;
    }
    async act_388211655357085_emit_7484_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_388211655357085_request_7482_getActionArgs($event) {
        return {
            operation: "update_invoice_notes",
            data: { id: this.invoice.id, text: $event.data.value.text },
        };
    }
    async evh_388211655357085_save(event, scope) {
        return await this.actions.evh_388211655357085_save.executeFromDOM(this, event, scope);
    }
    async act_4152404563918957_emit_7486_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4152404563918957_reload(event, scope) {
        return await this.actions.evh_4152404563918957_reload.executeFromDOM(this, event, scope);
    }
    async act_3855552110905499_emit_7488_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3855552110905499_reload(event, scope) {
        return await this.actions.evh_3855552110905499_reload.executeFromDOM(this, event, scope);
    }
    async act_4039445435535707_emit_7490_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4039445435535707_reload(event, scope) {
        return await this.actions.evh_4039445435535707_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_388211655357085_emit_7484 = new core_1.actions.EmitAction({
            actionArgs: this.act_388211655357085_emit_7484_getActionArgs,
            events: [],
        });
        const evh_388211655357085_success_7483 = new core_1.actions.EventHandlerImpl({
            action: act_388211655357085_emit_7484,
            event: "success",
            displayName: "emit",
        });
        const act_388211655357085_request_7482 = new core_1.actions.RequestAction({
            actionArgs: this.act_388211655357085_request_7482_getActionArgs,
            displayName: "saveNotes",
            events: [evh_388211655357085_success_7483],
        });
        const evh_388211655357085_save_7481 = new core_1.actions.EventHandlerImpl({
            action: act_388211655357085_request_7482,
            event: "save",
            displayName: "saveNotes",
        });
        const evh_388211655357085_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_388211655357085_save_7481],
        });
        const act_4152404563918957_emit_7486 = new core_1.actions.EmitAction({
            actionArgs: this.act_4152404563918957_emit_7486_getActionArgs,
            events: [],
        });
        const evh_4152404563918957_reload_7485 = new core_1.actions.EventHandlerImpl({
            action: act_4152404563918957_emit_7486,
            event: "reload",
            displayName: "emit",
        });
        const evh_4152404563918957_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4152404563918957_reload_7485],
        });
        const act_3855552110905499_emit_7488 = new core_1.actions.EmitAction({
            actionArgs: this.act_3855552110905499_emit_7488_getActionArgs,
            events: [],
        });
        const evh_3855552110905499_reload_7487 = new core_1.actions.EventHandlerImpl({
            action: act_3855552110905499_emit_7488,
            event: "reload",
            displayName: "emit",
        });
        const evh_3855552110905499_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3855552110905499_reload_7487],
        });
        const act_4039445435535707_emit_7490 = new core_1.actions.EmitAction({
            actionArgs: this.act_4039445435535707_emit_7490_getActionArgs,
            events: [],
        });
        const evh_4039445435535707_reload_7489 = new core_1.actions.EventHandlerImpl({
            action: act_4039445435535707_emit_7490,
            event: "reload",
            displayName: "emit",
        });
        const evh_4039445435535707_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4039445435535707_reload_7489],
        });
        return {
            act_388211655357085_emit_7484,
            evh_388211655357085_success_7483,
            act_388211655357085_request_7482,
            evh_388211655357085_save_7481,
            evh_388211655357085_save,
            act_4152404563918957_emit_7486,
            evh_4152404563918957_reload_7485,
            evh_4152404563918957_reload,
            act_3855552110905499_emit_7488,
            evh_3855552110905499_reload_7487,
            evh_3855552110905499_reload,
            act_4039445435535707_emit_7490,
            evh_4039445435535707_reload_7489,
            evh_4039445435535707_reload,
            saveNotes: act_388211655357085_request_7482,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceData.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceData.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], UcInvoiceData.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceData.prototype, "onForm_id", null);
UcInvoiceData = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceData);
exports.default = UcInvoiceData;
vue_property_decorator_1.Vue.component("UcInvoiceData", UcInvoiceData);
